<template>
  <div class="amount-panel-container">
    <div class="label">应退金额</div>
    <div class="value">¥{{ data.paidAmount | amount }}</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.amount-panel-container {
  margin: 28px 0;
  display: flex;
  justify-content: space-between;
  font-size: 28px;
  line-height: 28px;
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
  padding: 32px 28px;
}
</style>